export default __webpack_public_path__ + "static/media/arts_mobile.defbfe42.svg";